import http_request from './http_request'
import config from 'config'
import externalApiTypes from 'helpers/enums/externalApiTypes'

function getFlocabularyCategories() {
	return http_request.get(config.api + 'flocabulary/categories')
		.send()
}

function getResultsByTopic(topic, isSubject, page) {
	return http_request.get(config.api + 'flocabulary/videos')
		.send({
			topic,
			isSubject,
			page,
		})
}

function getResultsBySearch(query, page) {
	return http_request.get(config.api + 'flocabulary/videos/search')
		.send({
			query,
			page,
		})
}

function getVideo(videoId, jwt) {
	let headers = {}
	if (jwt) {
		headers = {
			jwt,
			'x-api-key': externalApiTypes.FLOCABULARY_UID,
		}
	}
	return http_request.get(config.api + 'flocabulary/videos/video')
		.withHeaders(headers)
		.send({videoId})
}

export default {
	getVideo,
	getFlocabularyCategories,
	getResultsByTopic,
	getResultsBySearch,
}
